import { useEffect, useState } from "react";
import { useUiStore } from "src/components/main/uiStore";
//-----------------------------------
import Modal from "src/components/common/Modal";
import { myAxios} from "src/components/common/functions";
import { useNavigate } from "react-router-dom";
//-----------------------------------
type settings = {Region?: string[]}
export default function UserSettingsForm(){
    // to get settings, currently only region list.
    // to update settings, currently only add/delete region.
    // if time, can add more settings and make it more flexible to update settings.
    // for region, when delete, if there are users in that region, need to move them to other region or empty before delete.
    // for region, when add, just add to settings, no need to update users.
    // for region, when delete, just delete from settings, no need to update users, but when display users, if user's region is not in settings, display as empty.
    // move useEffect to aciton loader settingsLoader, and make it more flexible to get different settings. 
    // for example, can get region list, department list, etc. in one request, and store them in mainStore, 
    // and provide functions to update them in mainStore, 
    // and call those functions in this component when add/delete region/department, etc.
    const navigate = useNavigate();
    const setShowLoader = useUiStore(state => state.setShowLoader);
    const [settings, setSettings] = useState<settings>({});
    const [showLoading, setShowLoading] = useState(true);
    useEffect(() => {
        let isMouted = true;
        const getData = async() => {
            const formData = new FormData();
            formData.append("mode", "Read");
            const res = await myAxios({ fileName: "users/settings.php", formData: formData });
            if(!isMouted) return;
            setShowLoader(false);
            if(!res) return;
            //-----------------------------------
            setSettings(res.data);
            setShowLoading(false);
        }
        getData();
        return () => { isMouted = false; }
    }, [setShowLoader])
    return (
        <Modal
            touchOutsideClose = {true}
            closeIt = {() => navigate("..")}
            title = "Settings"
            width = {1000} maxWidth = {"100%"}
        >
            {showLoading?
            <div className = "my-2">Loading...</div>
            :
            <>
            <div className = "my-2">
                <h4>Region</h4>
                <ul>
                    {settings.Region?.map((u, key) => 
                    <li key = {key} className = "mt-2">
                        {u}
                        <span
                            className = "btn btn-danger ms-2"
                            onClick = {async() => {
                                if(!window.confirm("Are you sure to delete this region?")) return;
                                const formData = new FormData();
                                formData.append("mode", "Add");
                                setShowLoader(true);
                                const res = await myAxios({ fileName: "users/setttings.php", formData: formData });
                                setShowLoader(false);
                                if(!res) return;
                                setSettings(settings);
                            }}
                        >
                            Delete
                        </span>
                    </li>)}
                </ul>
                <span
                    className = "btn btn-success"
                    onClick = {async() => {
                        const formData = new FormData();
                        formData.append("mode", "Add");
                        setShowLoader(true);
                        const res = await myAxios({ fileName: "users/setttings.php", formData: formData });
                        setShowLoader(false);
                        if(!res) return;
                        setSettings(settings);
                    }}
                >
                    Add
                </span>
            </div>
            </>
            }
        </Modal>
    )
}